import { useGetUserInfo } from "features/users/hooks/useGetUserInfo";

export default function useGetWalletAddress() {
    return useGetUserInfo({ select: (data) => data?.wallet?.address });
}
